import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=76c4d0f6&scoped=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=76c4d0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c4d0f6",
  null
  
)

export default component.exports